/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNotificationsQueryVariables = Types.Exact<{
  country: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetNotificationsQuery = { __typename: 'Query', getNotifications: Array<{ __typename: 'NotificationNext', id: string, story_id: string | null, notification_type: string, story: { __typename: 'Feed', id: string, updated_at: string, campaign_id: number, campaign: { __typename: 'Campaign', id: string | null, name: string | null, label_id: string | null, parent_id: string | null, artist: { __typename: 'Artist', id: string | null, name: string | null, facebook_id: string | null, spotify_id: string | null } | null } } | null, campaign: { __typename: 'Campaign', id: string | null, name: string | null, owner_id: number | null, label_id: string | null, created_at: string | null, artist: { __typename: 'Artist', id: string | null, name: string | null, facebook_id: string | null, spotify_id: string | null } | null } | null, product: { __typename: 'Product', id: string | null, name: string | null, parent_id: string | null, publish_date: string | null, configuration: string | null, campaign: { __typename: 'Campaign', id: string | null, name: string | null, label_id: string | null, artist: { __typename: 'Artist', id: string | null, name: string | null } | null } | null } | null, properties: { __typename: 'NotificationProps', gcdm_matches: Array<{ __typename: 'GcdmMatch', artistDisplayTitle: string, gpid_list: Array<string | null>, displayTitle: string, dv_entity_id: string | null, dv_group_id: string | null } | null> | null } | null }> | null };


export const GetNotificationsDocument = gql`
    query getNotifications($country: String) {
  getNotifications(country: $country) {
    id
    story_id
    story {
      id
      updated_at
      campaign_id
      campaign {
        id
        name
        label_id
        parent_id
        artist {
          id
          name
          facebook_id
          spotify_id
        }
      }
    }
    campaign {
      id
      name
      owner_id
      label_id
      created_at
      artist {
        id
        name
        facebook_id
        spotify_id
      }
    }
    product {
      id
      name
      parent_id
      publish_date
      configuration
      campaign {
        id
        name
        label_id
        artist {
          id
          name
        }
      }
    }
    notification_type
    properties {
      gcdm_matches {
        artistDisplayTitle
        gpid_list
        displayTitle
        dv_entity_id
        dv_group_id
      }
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;